import React from 'react';
import { IconProps } from '../types/types';

const MCD: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#BD0017" d="M0 0h18v18H0z"/><path d="M11.185 3.71c.86 0 1.815 4.153 1.815 9.286L14 13c0-5.526-1.267-10-2.819-10C10.295 3 9.517 4.394 9 6.5 8.483 4.394 7.694 3 6.815 3 5.263 3 4 7.47 4 12.996L5 13c0-5.133.947-9.29 1.808-9.29.86 0 1.692 4.554 1.692 9.29h1c0-4.736.817-9.29 1.678-9.29" fill="#FC0"/></svg>
);

export default MCD;